import { encodeQueryData } from "./google"

export const getRedditAuthorizationLink = () => {
  const urlBase = `https://www.reddit.com/api/v1/authorize`
  const params = {
    client_id: process.env.NEXT_PUBLIC_REDDIT_CLIENT_ID ?? "missing-reddit-client-id",
    redirect_uri: process.env.NEXT_PUBLIC_REDDIT_REDIRECT_URI ?? "missing-reddit-redirect-uri",
    response_type: "code",
    state: "pass-through value",
    scope: "identity read mysubreddits modconfig submit",
    duration: "permanent",
  }

  const queryString = encodeQueryData(params)
  return `${urlBase}?${queryString}`
}

export const getRedditAppInstallUrl = () => {
  return `https://developers.reddit.com/apps/bonsai-app`
}
